import React from 'react'
import { FormattedMessage } from 'react-intl';
import './SSO-CMS.css'


class SSOConnect extends React.Component {
    render() {
        return(
            <div className={'card'} >
                <div className='row d-flex mx-3-shrink my-3-shrink'>
                    <div className='col-sm-10'>
                        <img className='pe-2' src="/images/warning-red.svg"/>
                        <label className='form-label red'><FormattedMessage id="CONNECT_TO_CLOUD_BTN_DESCRIPTION" /></label> 
                    </div>
                    <div className='col-sm-auto'>
                        <button type='button' className='btn btn-primary' onClick={this.props.onClickConnectBtn}>
                            <FormattedMessage id="CONNECT_TO_CLOUD_BTN_LABEL" />
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default SSOConnect;